import { Component, Input } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'wsb-atlas-collapse',
  templateUrl: './atlas-collapse.component.html',
  styleUrls: ['./atlas-collapse.component.scss'],
  animations: [
    trigger('toggleHeight', [
      state(
        'hide',
        style({
          height: '0px',
          opacity: '0',
          overflow: 'hidden'
        })
      ),
      state(
        'show',
        style({
          height: '*',
          opacity: '1'
        })
      ),
      transition('hide => show', animate('200ms ease-in')),
      transition('show => hide', animate('200ms ease-out'))
    ])
  ],
  styles: [
    `
      .collapsable {
        display: block;
      }
    `
  ],
  standalone: false
})
export class AtlasCollapseComponent {
  @Input() collapsed = true;
  @Input() label = 'label';
  @Input() labelClass = '';

  constructor() {}
}
